module.exports = __webpack_public_path__ + "media/img/home/our-work/photo-1-157df8eedd67250bb7ab89ce34227d9e.webp";